export default __webpack_public_path__ + "static/media/gallery-wip-pre-paint-assembly_00.a6bc2d40.jpg";